import {Component, Input, OnInit} from '@angular/core';
import {Idiomas} from '../../dominio/idiomas/idiomas';
import {ToastrService} from 'ngx-toastr';
import {LenguageService} from '../../services/lenguage.service';
import {StaticLenguageService} from '../../services/static-lenguage.service';
import {ActivatedRoute} from '@angular/router';
import {Response} from "../../dominio/Response";
import {ApiService} from "../../services/api.service";
import {NgProgress} from "ngx-progressbar";

@Component({
  selector: 'app-buttons-lenguage',
  templateUrl: './buttons-lenguage.component.html',
  styleUrls: ['./buttons-lenguage.component.scss']
})
export class ButtonsLenguageComponent implements OnInit {
    lenguage = new Array<Idiomas>();
    enable = false;
    constructor(private toastr: ToastrService,
                public ngProgress: NgProgress,
                private lenguageService: LenguageService,
                private apiService: ApiService,
                private staticLenguageService: StaticLenguageService,
                private route: ActivatedRoute) {
        this.lenguage = this.lenguageService.getLenguages();
    }

    ngOnInit() {}
    // Cambiar idioma del sitio
    changeLenguage(code) {
        this.lenguageService.langToUrl(code);
        this.staticLenguageService.setLenguages();
    }
	//verifica si el admin está editando o creando un investigador
	//se usa para ocultar los botones laterales de idiomas
	adminEdicion(){
		return this.lenguageService.adminEditando();
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/buttons-lenguage/buttons-lenguage.component.ts